const removeOptionColorValue = (optionName: string) =>
  // filter out hex/extra color codes from variant title
  // e.g. "Small / Blue:#30629e"
  optionName
    ?.split('/')
    .map(variantText => {
      // check for colon, means we probably have something like Blue:#30629e coming from shopify data
      let text = variantText;
      if (variantText.includes(':')) {
        const [variantTitle] = variantText.split(/[.?:]/);
        text = variantTitle.trim();
      }
      return text;
    })
    .join('/'); // set new value

export default removeOptionColorValue;
